import { Controller } from "@hotwired/stimulus"

// Inline message editing
// data-controller="message-edit"
// data-message-edit-url-value="/u/messages/123/edit"
export default class extends Controller {
  static values = { url: String }
  static targets = ["content"]

  startEdit() {
    if (!this.hasContentTarget || !this.urlValue) return

    const content = this.contentTarget
    const originalText = content.textContent.trim()

    // Replace content with textarea
    const textarea = document.createElement("textarea")
    textarea.value = originalText
    textarea.className = "w-full bg-transparent border-0 text-sm p-0 focus:ring-0 resize-none text-white"
    textarea.rows = Math.max(1, originalText.split("\n").length)
    textarea.style.outline = "none"

    // Save/Cancel buttons
    const actions = document.createElement("div")
    actions.className = "flex gap-2 mt-2 justify-end"
    actions.innerHTML = `
      <button type="button" data-action="message-edit#cancelEdit" class="text-xs px-2 py-1 rounded opacity-70 hover:opacity-100">Cancel</button>
      <button type="button" data-action="message-edit#saveEdit" class="text-xs px-2 py-1 rounded bg-white/20 hover:bg-white/30">Save</button>
    `

    // Store original for cancel
    this._originalHTML = content.innerHTML
    content.innerHTML = ""
    content.appendChild(textarea)
    content.appendChild(actions)

    textarea.focus()
    textarea.setSelectionRange(textarea.value.length, textarea.value.length)

    this._textarea = textarea
  }

  cancelEdit() {
    if (this.hasContentTarget && this._originalHTML) {
      this.contentTarget.innerHTML = this._originalHTML
    }
  }

  async saveEdit() {
    if (!this._textarea || !this.urlValue) return

    const newContent = this._textarea.value.trim()
    if (!newContent) return

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: JSON.stringify({ message: { content: newContent } })
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        this.cancelEdit()
      }
    } catch {
      this.cancelEdit()
    }
  }
}
